const VoteSecurity = {
    /**
     * Store a record that a user has voted in a specific poll
     * @param {string} pollId - ID of the poll 
     * @param {string} participantId - ID of the participant
     */
    recordVote: (pollId, participantId) => {
      try {
        // Store in localStorage
        const votedPolls = JSON.parse(localStorage.getItem('votedPolls') || '{}');
        votedPolls[pollId] = {
          participantId,
          timestamp: Date.now(),
          deviceId: getDeviceFingerprint()
        };
        localStorage.setItem('votedPolls', JSON.stringify(votedPolls));
        
        // Also store in sessionStorage as a backup
        sessionStorage.setItem(`voted_${pollId}`, 'true');
        
        // Set a cookie as an additional verification method
        document.cookie = `voted_${pollId}=true; path=/; max-age=${60 * 60 * 24 * 30}`; // 30 days
        
        return true;
      } catch (error) {
        console.error('Error recording vote:', error);
        return false;
      }
    },
    
    /**
     * Check if the current user/browser has already voted in a poll
     * @param {string} pollId - ID of the poll to check
     * @returns {boolean} - Whether the user has already voted
     */
    hasVoted: (pollId) => {
      try {
        // Check localStorage first
        const votedPolls = JSON.parse(localStorage.getItem('votedPolls') || '{}');
        if (votedPolls[pollId]) {
          return true;
        }
        
        // Check sessionStorage as backup
        if (sessionStorage.getItem(`voted_${pollId}`) === 'true') {
          return true;
        }
        
        // Check cookies as final verification
        if (document.cookie.includes(`voted_${pollId}=true`)) {
          return true;
        }
        
        return false;
      } catch (error) {
        console.error('Error checking vote status:', error);
        return false; // In case of error, default to allowing a vote
      }
    },
    
    /**
     * Get a list of all polls the user has voted in
     * @returns {string[]} - Array of poll IDs the user has voted in
     */
    getAllVotedPolls: () => {
      try {
        const votedPolls = JSON.parse(localStorage.getItem('votedPolls') || '{}');
        return Object.keys(votedPolls);
      } catch (error) {
        console.error('Error getting voted polls:', error);
        return [];
      }
    }
  };
  
  /**
   * Generate a simple device fingerprint based on browser information
   * This is not foolproof but adds another layer of identification
   */
  function getDeviceFingerprint() {
    const nav = window.navigator;
    const screen = window.screen;
    
    // Collect various browser/device characteristics
    const fingerprint = [
      nav.userAgent,
      nav.language,
      screen.colorDepth,
      screen.width + 'x' + screen.height,
      new Date().getTimezoneOffset(),
      !!window.sessionStorage,
      !!window.localStorage,
      !!window.indexedDB
    ].join('|');
    
    // Create a simple hash of the fingerprint
    let hash = 0;
    for (let i = 0; i < fingerprint.length; i++) {
      const char = fingerprint.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32bit integer
    }
    
    return hash.toString(36);
  }
  
export default VoteSecurity;